/**
 * JS for integration with voip softphone
 */
function addVoipAction(name, parameters) {
    var actions = localStorage.getItem('simpro_voipAction') || "[]";
    actions = JSON.parse(actions) || [];
    actions.push({
        'action': name,
        'parameters': parameters
    });
    localStorage.setItem('simpro_voipAction', JSON.stringify(actions));
}

var CLICK_TO_CALL_MIN_NUMBER_LENGTH = 6;

// When the page is loaded / refreshed via ajax, hide click-2-call icons for blank / short phone numbers
preparePages.push('prepareClickToCallIcons');
function prepareClickToCallIcons(context) {
    $('.numberForVoip-js', context).each(function (i, input) {
        showOrHideClickToCallIcon($(input));
    });
}

// Open softphone in new window when clicking on voip icon
$(document).on("click", '#voipSettings', function(e) {
    e.preventDefault();
    openSoftphoneWindow();
});

// Enable click to call buttons
$(document).on("click", '.clickToCall-js', function(e) {
    e.preventDefault();
    var number = $(this).closest('.groupedInput').find('.numberForVoip-js').val();

    // Replace all non-numeric and non '+' characters (and ensure it's a leading + only)
    number = number.replace(/[^0-9\+]/g, "");
    let numberStartsWithPlus = number.match(/^\+/);
    number = number.replace(/\+/g, "");
    if (numberStartsWithPlus !== null) {
        number = '+' + number;
    }

    if (number !== '' ) {
        var voipConfig = simPRODefaults.data('voipConfig');

        // Add area and country code if number does not start with double zeros or +.
        if (!number.match(/^00/) && !number.match(/^\+/)) {
            if (voipConfig.areaCode.length) {
                // If the number does not start with a zero, add area code.
                if (number.match(/^[^0]/)) {
                    number = voipConfig.areaCode + number;
                }
            }

            if (voipConfig.countryCode.length) {
                // If the number starts with a zero, strip it.
                if (number.match(/^0/)) {
                    number = number.substring(1);
                }

                // Finally, add the country code
                number = voipConfig.countryCode + number;
            }
        }

        // Add any sip prefix number.
        number = voipConfig.prefix + number;

        openSoftphoneWindow(false);
        addVoipAction('call', [number]);
    }
}).on("keyup", '.numberForVoip-js', function() {
    showOrHideClickToCallIcon($(this));
});

function showOrHideClickToCallIcon($input) {
    var cssDisplay = ($input.val().replace(/[^0-9]/g, '').length >= CLICK_TO_CALL_MIN_NUMBER_LENGTH) ? '' : 'none';
    $input.closest('.groupedInput').find('.clickToCall-js').css('display', cssDisplay);
}

function openSoftphoneWindow(notify) {
    if (typeof notify === 'undefined') {
        notify = true;
    }

    var url = "/" + simPRODefaults.data('urlPrefix') + "staff/webphone/softphone.php";

    // Check localStorage to see if the window is already open.
    // We do this instead of var voipWindow = window.open(...) because local storage persists
    // even if the main simPRO tab is closed, or if the click-to-call link is within an iframe.
    if (!localStorage.getItem('simpro_voipWindow')) {
        PopupBottomLeft(url, 'simpro_voip', 350, 450);
    } else {
        // The window is allegedly open. Make sure.
        // If the voip window is open it will immediately recreate the local storage entry after we delete it
        // See application/staff/webphone/softphone.php, ~line 50.
        localStorage.removeItem('simpro_voipWindow');

        // Wait a moment for the voip window to pick-up the local storage change and recreate the entry.
        setTimeout(function() {
            if (!localStorage.getItem('simpro_voipWindow')) {
                // The entry has not been recreated. Re-open the window.
                PopupBottomLeft(url, 'simpro_voip', 350, 450);
            } else if (notify) {
                // The window is actually open. Make a notification so the user can bring it into focus.
                addVoipAction('focus');
            }
        }, 100);
    }
}

function PopupBottomLeft(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = dualScreenLeft + 5;
    var top =  dualScreenTop === 0 ? (height - h) - 50  : (dualScreenTop + h) - 50;
    var newWindow = window.open(url, title, 'scrollbars=yes,toolbar=no,location=no,status=no,menubar=no,resizable=yes,width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
